import React, { createContext, useContext, useEffect, useState } from "react";

type Lang = "lt" | "en";

const resources: Record<Lang, Record<string, string>> = {
  lt: {
    home: "Pradžia",
    buses: "Autobusų nuoma",
    microbuses: "Mikroautobusų nuoma",
    contact: "Kontaktai",
    logoAlt: "Transrentus logotipas",
    langLT: "LT",
    langEN: "EN",
    heroTitle: "AUTOBUSŲ BEI MIKROAUTOBUSŲ NUOMA",
    heroSubtitle: "Kokybiškos keleivių pervežimo paslaugos Lietuvoje ir užsienyje",
    offerTitle: "MES JUMS SIŪLOME",
    busesColumn: "NUOMOJAMI AUTOBUSAI",
    microbusesColumn: "NUOMOJAMI MIKROAUTOBUSAI",
    viewOffers: "Žiūrėti pasiūlymus",
    feature1Title: "AUTOBUSŲ IR MIKROAUTOBUSŲ NUOMA",
    feature1Text:
      "Tvarkingų, komfortabilių, patogių mikroautobusų ir autobusų nuoma, turistinėms kelionėms, ekskursijoms, verslo susitikimams, poilsinėms išvykoms po Lietuvą ir į užsienį.",
    feature1Highlight: "Platus autobusų bei mikroautobusų asortimentas.",
    feature2Title: "AUKŠTA PASLAUGŲ KOKYBĖ BEI PATRAUKLIOS KAINOS",
    feature2Text:
      "Klientams suplanouojame kelionės maršrutą ir suskaičiuojame visą transporto paslaugos kainą. Rekomenduojame nakvynės vietas kelionės metu.",
    feature2Highlight: "Vežame patogiai, saugiai ir greitai.",
    feature3Title: "MŪSŲ TIKSLAS",
    feature3Text:
      "Klientams užtikrinti aukštą paslaugų kokybę, geri santykiai su verslo partneriais ir konkurentais, dinamika ir visapusiška įmonės plėtra.",
    feature3Highlight: "aukštą paslaugų kokybę",
    aboutUsTitle: "APIE MUS",
    aboutUsText: `UAB „TRANSRENTUS“ - keleivinio transporto paslaugų įmonė, įsikūrusi Kaune. Savo veiklą pradėjome 1992 m. nuo individualios Kęstučio Baladinsko įmonės, kuri sėkmingai veikė iki 2002 metų.

  Taikydamiesi prie Lietuvos ir Europos Sąjungos reformų bei įstatymų 2002 metais, Kęstučio Baladinsko įmonę reorganizavome į UAB „TRANSRENTUS“, kuri ir toliau sėkmingai teikia kokybiškas keleivių vežimo paslaugas Lietuvoje ir užsienyje.

  Planuojate vykti į pažintinę ar verslo kelionę? Organizuojate mokinių ekskursijas po Lietuvą ar Europą? Jums reikalingas transportas Jūsų šventėms: vestuvėms, mergvakariams, bernvakariams?... Mūsų kvalifikuota darbuotojų komanda, turėdama ilgametę patirtį, padės Jums išsirinkti geriausią kelionės maršrutą! Taip pat, pagal Jūsų poreikius, galės pasiūlyti platų autobusų ir mikroautobusų asortimentą, kvalifikuotus ir profesionalius vairuotojus, kurie garantuos Jūsų kelionės sėkmę bei neišdildomus įspūdžius.

  Teikdami užsakomųjų reisų autobusų nuomos bei mikroautobusų nuomos paslaugas, užtikrinsime patikimumą ir aukštą paslaugų kokybę Jūsų kelionės metu. Susisiekite su mumis ir mes padėsime Jums išspręsti visus keleivių pervežimo klausimus.

  Autobusų nuomos paslaugas teikiame Kaune, Vilniuje, Marijampolėje, Alytuje ir kituose miestuose.`,
    padekosTitle: "PADĖKOS",
    padekaCaption: "Padėkos, sertifikatai ir įvertinimai",
    busesPlaceholder: "Autobusų sąrašas (LAIKINAS TURINYS)",
    microbusesPlaceholder: "Mikroautobusų sąrašas (LAIKINAS TURINYS)",
    contactPlaceholder: "Kontaktinė informacija bus pridėta čia.",
    notFoundTitle: "Puslapis nerastas",
    notFoundText: "Užklausta puslapis neegzistuoja arba dar nesukurtas.",
    busDetailTitle: "Autobusas",
    microbusDetailTitle: "Mikroautobusas",
    seatsLabel: "Vietų skaičius",
    tankLabel: "Bako talpa",
    fuelLabel: "Kuro sąnaudos",
    advantagesLabel: "Privalumai",
    busPlan: "Autobuso planas",
    adv_airConditioning: "Oro kondicionierius",
    adv_video: "Video (DVD), CD",
    adv_cd: "CD grotuvas",
    adv_microphone: "Mikrofonas",
    adv_kitchen: "Virtuvėlė",
    adv_fridge: "Šaldytuvas",
    adv_two_fridges: "Du šaldytuvai",
    adv_wc: "WC",
    adv_separate_heating: "Atskiras šildymas",
    adv_navigation: "Navigacija (GPS)",
    adv_panoramic_windows: "Panoraminiai langai",
    adv_trunk: "Bagažinė",
    contactPrompt: "Norėdami sužinoti apie šiuo metu galimą išsinuomoti transportą ir kainas, susisiekite su mumis ir pagal Jūsų poreikius mes pasiūlysime Jums optimaliausią variantą.",
    contactThanks: "Ačiū! Gavome jūsų žinutę.",
    contactError: "Klaida siunčiant žinutę. Bandykite dar kartą vėliau.",
    contactDemoError: "Programa demo režimu — informacijos priimti negalime.",
    contactTitle: "Susisiekite su mumis!",
    contactSubtitle: "Užduokite mums klausimą ar siųskite pasiūlymą užpildę žemiau esančią formą.",
    contactName: "Vardas *",
    contactEmail: "El. paštas *",
    contactSubject: "Tema *",
    contactMessage: "Žinutė *",
    contactSubmit: "Siųsti",
    contactRequisites: "REKVIZITAI",
    contactDesc: "turistinių autobusų nuoma keleiviams. Autobusų nuoma grupėms. Mikroautobusų nuoma. Autobusų nuoma geromis kainomis.",
    contactRegAddress: "Registracijos adresas:",
    contactOfficeAddress: "Buveinės adresas:",
    contactMobile: "Mob.:",
    contactTelFax: "Tel./Fax:",
    contactCompanyCode: "Įmonės kodas",
    contactVatCode: "PVM kodas",
    footerContacts: "KONTAKTAI",
    footerBusHeading: "KELEIVINIAI AUTOBUSAI",
    footerFollow: "SEKITE MUS",
    footerBusDesc: "Turistinių autobusų nuoma kelionėms. Autobusų nuoma grupėms. Mikroautobusų nuoma. Autobusų nuoma geromis kainomis.",
    footerSolution: "Sprendimas:",
    seoHomeTitle: "Autobusų nuoma Kaune | Transrentus",
    seoHomeDesc: "Transrentus – autobusų ir mikroautobusų nuoma Kaune, Vilniuje ir visoje Lietuvoje. Autobuso nuoma kelionėms, ekskursijoms ir renginiams. Susisiekite! +370 698 82999.",
    seoBusesTitle: "Autobusų nuoma Kaune – nuomojami autobusai | Transrentus",
    seoBusesDesc: "Autobusų nuoma Kaune ir visoje Lietuvoje. Nuomojame turistinius autobusus SETRA. Aukšta paslaugų kokybė, patrauklios kainos.",
    seoMicrobusesTitle: "Mikroautobusų nuoma Kaune – nuomojami mikroautobusai | Transrentus",
    seoMicrobusesDesc: "Mikroautobusų nuoma Kaune ir visoje Lietuvoje. Mercedes-Benz Sprinter, Volkswagen Crafter. Grupėms, kelionėms, renginiams.",
    seoContactTitle: "Kontaktai – autobusų nuoma Kaune | Transrentus",
    seoContactDesc: "Susisiekite su Transrentus – autobusų ir mikroautobusų nuoma. Šiauriečių aklg. 17, Kaunas. Mob. +370 698 82999.",
  },
  en: {
    home: "Home",
    buses: "Bus Rent",
    microbuses: "Microbus Rent",
    contact: "Contact",
    logoAlt: "Transrentus logo",
    langLT: "LT",
    langEN: "EN",
    heroTitle: "BUS AND MICROBUS RENTAL",
    heroSubtitle: "Quality passenger transportation services in Lithuania and abroad",
    offerTitle: "WHAT WE OFFER",
    busesColumn: "RENTAL BUSES",
    microbusesColumn: "RENTAL MICROBUSES",
    viewOffers: "View offers",
    aboutUsTitle: "ABOUT US",
    aboutUsText: `UAB "TRANSRENTUS" is a passenger transportation services company based in Kaunas. Our activity began in 1992 from the private enterprise of Kęstutis Baladinskas, which operated successfully until 2002.

Adapting to the reforms and laws of Lithuania and the European Union in 2002, Kęstutis Baladinskas's company was reorganized into UAB "TRANSRENTUS", which continues to successfully provide quality passenger transportation services in Lithuania and abroad.

Planning a leisure or business trip? Organizing student excursions around Lithuania or Europe? Need transportation for your events: weddings, bachelor/bachelorette parties? Our qualified team, with many years of experience, will help you choose the best travel route! Also, according to your needs, we can offer a wide selection of buses and microbuses, qualified and professional drivers who will ensure the success of your trip and lasting impressions.

By providing charter bus and microbus rental services, we ensure reliability and high service quality during your trip. Contact us and we will help you solve all passenger transport issues.

We provide bus rental services in Kaunas, Vilnius, Marijampolė, Alytus and other cities.`,
    feature1Title: "BUS AND MICROBUS RENTAL",
    feature1Text:
      "Well-maintained, comfortable, and convenient microbuses and buses for tourist trips, excursions, business meetings, and leisure trips in Lithuania and abroad.",
    feature1Highlight: "Wide selection of buses and microbuses.",
    feature2Title: "HIGH SERVICE QUALITY AND ATTRACTIVE PRICES",
    feature2Text:
      "We plan travel routes for clients and calculate the total cost of transport services. We recommend accommodation options during the trip.",
    feature2Highlight: "We transport comfortably, safely, and quickly.",
    feature3Title: "OUR GOAL",
    feature3Text:
      "Ensuring high service quality for clients, maintaining good relationships with business partners and competitors, and pursuing dynamic and comprehensive company growth.",
    feature3Highlight: "high service quality",
    padekosTitle: "THANK YOU CERTIFICATES",
    padekaCaption: "Thank-you certificates and recognitions",
    busesPlaceholder: "Buses listing (PLACEHOLDER CONTENT)",
    microbusesPlaceholder: "Microbuses listing (PLACEHOLDER CONTENT)",
    contactPlaceholder: "Contact information will be added here.",
    notFoundTitle: "Page not found",
    notFoundText: "The requested page doesn't exist or hasn't been created yet.",
    busDetailTitle: "Bus",
    microbusDetailTitle: "Microbus",
    seatsLabel: "Seats",
    tankLabel: "Tank capacity",
    fuelLabel: "Fuel consumption",
    advantagesLabel: "Advantages",
    busPlan: "Bus plan",
    adv_airConditioning: "Air conditioning",
    adv_video: "Video (DVD), CD",
    adv_cd: "CD player",
    adv_microphone: "Microphone",
    adv_kitchen: "Kitchenette",
    adv_fridge: "Fridge",
    adv_two_fridges: "Two fridges",
    adv_wc: "WC",
    adv_separate_heating: "Separate heating",
    adv_navigation: "Navigation (GPS)",
    adv_panoramic_windows: "Panoramic windows",
    adv_trunk: "Trunk",
    contactPrompt: "To find out what vehicles and prices are currently available for rent, contact us and we will propose the best option tailored to your needs.",
    contactThanks: "Thank you! We received your message.",
    contactError: "Failed to send message. Please try again later.",
    contactDemoError: "This application is in demo mode and does not receive information.",
    contactTitle: "Contact us!",
    contactSubtitle: "Ask us a question or send an offer by filling in the form below.",
    contactName: "Name *",
    contactEmail: "Email *",
    contactSubject: "Subject *",
    contactMessage: "Message *",
    contactSubmit: "Send",
    contactRequisites: "DETAILS",
    contactDesc: "tourist bus rental for passengers. Bus rental for groups. Minibus rental. Bus rental at great prices.",
    contactRegAddress: "Registration address:",
    contactOfficeAddress: "Office address:",
    contactMobile: "Mob.:",
    contactTelFax: "Tel./Fax:",
    contactCompanyCode: "Company code",
    contactVatCode: "VAT code",
    footerContacts: "CONTACTS",
    footerBusHeading: "PASSENGER BUSES",
    footerFollow: "FOLLOW US",
    footerBusDesc: "Tourist bus rental for trips. Bus rental for groups. Minibus rental. Bus rental at great prices.",
    footerSolution: "Solution:",
    seoHomeTitle: "Bus Rental in Kaunas | Transrentus",
    seoHomeDesc: "Transrentus - bus and minibus rental in Kaunas, Vilnius and across Lithuania. Bus hire for trips, excursions and events. Contact us! +370 698 82999.",
    seoBusesTitle: "Bus Rental in Kaunas - rental buses | Transrentus",
    seoBusesDesc: "Bus rental in Kaunas and across Lithuania. SETRA tourist coaches for rent. High service quality, attractive prices.",
    seoMicrobusesTitle: "Minibus Rental in Kaunas - rental microbuses | Transrentus",
    seoMicrobusesDesc: "Minibus rental in Kaunas and across Lithuania. Mercedes-Benz Sprinter, Volkswagen Crafter. For groups, trips and events.",
    seoContactTitle: "Contact - bus rental in Kaunas | Transrentus",
    seoContactDesc: "Contact Transrentus for bus and minibus rental. Šiauriečių aklg. 17, Kaunas. Mob. +370 698 82999.",
  },
};

interface I18nContextValue {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: string) => string;
}

const I18nContext = createContext<I18nContextValue>({
  lang: "lt",
  setLang: () => { },
  t: (k) => k,
});

export const I18nProvider = ({ children }: { children: React.ReactNode }) => {
  const [lang, setLangState] = useState<Lang>(() => {
    try {
      const saved = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
      return ((saved as Lang) || "lt") as Lang;
    } catch (e) {
      return "lt";
    }
  });

  useEffect(() => {
    try {
      if (typeof window !== "undefined") localStorage.setItem("lang", lang);
    } catch (e) { }
  }, [lang]);

  const setLang = (l: Lang) => setLangState(l);

  const t = (key: string) => {
    return resources[lang][key] ?? resources["lt"][key] ?? key;
  };

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useTranslation = () => useContext(I18nContext);

export default I18nProvider;
